import { render, staticRenderFns } from "./ArticleModule.vue?vue&type=template&id=640a7525&scoped=true&"
import script from "./ArticleModule.vue?vue&type=script&lang=ts&"
export * from "./ArticleModule.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleModule.vue?vue&type=style&index=0&id=640a7525&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640a7525",
  null
  
)

export default component.exports